import {Component, Input} from '@angular/core';
import {CampaignSection, CampaignSideBarSections} from '../../_models';

@Component({
  templateUrl: './campaign-sidebar.component.html',
  styleUrls: ['./campaign-sidebar.component.scss'],
  selector: 'app-campaign-sidebar'
})
export class CampaignSidebarComponent {
  public sidebarSections = CampaignSideBarSections;
  @Input('section') section: CampaignSection = CampaignSection.General;

  isSectionActive(section: CampaignSection) {
    return this.section === section;
  }
}
